<template>
  <div class="zv-page">
    <div class="zv-content">
      <div class="zv-block">
        <zv-table :table="table" ref="dataTable">
          <div slot="ctrl-button">
            <el-button type="primary" @click="doAdd()">新增</el-button>
          </div>
        </zv-table>

        <zv-dialog
          width="400px"
          :title="isEdit ? '修改成员' : '新增成员'"
          :showDialog.sync="showFormDialog"
          @close-dialog="closeFormDialog"
        >
          <div slot="content">
            <el-form
              ref="myForm"
              label-width="140px"
              :model="formData"
              :rules="formRules"
              status-icon
            >
              <el-form-item label="用户名：" prop="username">
                <el-input v-model="formData.username" clearable></el-input>
              </el-form-item>
              <el-form-item label="真实姓名：" prop="realname">
                <el-input v-model="formData.realname" clearable></el-input>
              </el-form-item>
              <el-form-item label="密码：" prop="password">
                <el-input v-model="formData.password" clearable></el-input>
              </el-form-item>
              <el-form-item label="角色名称：" prop="role">
                <el-select
                  v-model="formData.role"
                  filterable
                  clearable
                >
                  <el-option
                    v-for="item in roleListData"
                    :key="item.id"
                    :label="item.rolename"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="权限名称：" prop="rightcode">
                <el-select
                  v-model="formData.rightcode"
                  filterable
                  clearable
                  multiple
                >
                  <el-option
                    v-for="item in rightCodeListData"
                    :key="item.id"
                    :label="item.rightname"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-form>
          </div>
          <div slot="btns">
            <el-button @click="showFormDialog = false">取消</el-button>
            <el-button type="primary" @click="submitForm">确定</el-button>
          </div>
        </zv-dialog>
      </div>
    </div>
  </div>
</template>
<script>
import api from "./api";
import addFormMixin from "@/mixins/addFormMixin";
export default {
  name: "MemberList",
  mixins: [addFormMixin],
  components: {
  },
  data() {
    let vm = this;
    return {
      table: {
        api: api.companyMemberList,
        query: {

        },
        searchData: [
          {
            type: "input",
            model: "username",
            placeholder: "角色名称"
          },
          {
            type: "input",
            model: "username",
            placeholder: "父级角色"
          }
        ],
        columns: [
          {
            title: "编号",
            key: "id",
            minWidth:"50",
          },
          {
            title: "角色名称",
            key: "username",
            minWidth:"150",
            showTooltip: true
          },
          {
            title: "父级角色",
            key: "realname",
            minWidth:"150",
            showTooltip: true
          },
          {
            title: "角色简介",
            key: "role_name",
            minWidth:"150",
            showTooltip: true
          },
          {
            title: "创建时间",
            key: "role_name",
            minWidth:"150",
            showTooltip: true
          },
          {
            title: "启用状态",
            key: "role_name",
            minWidth:"150",
            showTooltip: true
          },
          {
            title: "操作人",
            key: "role_name",
            minWidth:"150",
            showTooltip: true
          },
          {
            title: "操作",
            fixed: "right",
            minWidth:"150",
            render(h, ctx) {
              const editBtn = h(
                "el-button",
                {
                  attrs: {
                    type: "text"
                  },
                  on: {
                    click: vm.doEdit.bind(this, ctx.row)
                  }
                },
                "修改"
              );

              const delBtn = h(
                "el-button",
                {
                  attrs: {
                    type: "text"
                  },
                  on: {

                    click: vm.doDelete.bind(this, ctx.row.id)


                  }


                },

                "删除"

              );

              let arr = [];
              arr.push(editBtn);

              arr.push(delBtn);

              return h("span", arr);
            }
          }
        ]
      },
      formDataOri: {
        username: '',  // 登录名
        realname: '',  // 用户真实姓名
        password: '',  // 密码
        role: '',       // 角色代码
        role_name: '',  // 角色名称
        rightcode: '', // 权限代码
        rightcode_name: '', // 权限名称
      },
      formRulesOri: {
        username: [{
          required: true,
          message: "用户名不能为空",
          trigger: "blur"
        }],
        realname: [{
          required: true,
          message: "真实姓名不能为空",
          trigger: "blur"
        }],
        role: {
          required: true,
          message: "请选择角色",
          trigger: "change"
        }
      },
      pwdRule: {
        password: [{
          required: true,
          message: "密码不能为空",
          trigger: "blur"
        }],
      },
      adddApi: api.addMember,
      editApi: api.editMember,
      deleteApi: api.deleteMember,
      formRules: {},
      addSuccessMsg: '添加成员成功',
      editSuccessMsg: '编辑成员成功',
      deleteSuccessMsg: '删除成员成功',
      roleListData: [],  // 角色数据
      rightCodeListData: []  // 权限数据
    };
  },

  computed: {

  },

  methods: {
    doAddExtra() {
      this.formRules = Object.assign({}, this.formRulesOri, this.pwdRule)
    },

    doEditExtra() {
      this.formRules = Object.assign({}, this.formRulesOri)
    },

    dealEditItem(editItem) {
      let retObj = this.$_.cloneDeep(editItem)
      retObj.role = parseInt(retObj.role)
      retObj.rightcode = retObj.rightcode ? retObj.rightcode.split(',').map(item => parseInt(item)) : []
      return retObj
    },

    beforeSubmit() {
      this.submitData.rightcode = this.submitData.rightcode.join(",")
      // 编辑时如果求填写密码，则不传password字段
      if (this.isEdit && !this.formData.password) {
        delete this.submitData.password
      }
    },
  },

  created() {
    this.$api.getRoleList().then(res => {
      this.roleListData = res.data
    })

    this.$api.getRightCodeList().then(res => {
      this.rightCodeListData = res.data
    })
  },

  mounted() {

  },
  beforeDestroy() {

  }
};
</script>

<style lang="less" scoped>

</style>
